import { render, staticRenderFns } from "./ztmoreList.vue?vue&type=template&id=8ca89fa6&scoped=true&"
import script from "./ztmoreList.vue?vue&type=script&lang=js&"
export * from "./ztmoreList.vue?vue&type=script&lang=js&"
import style0 from "./ztmoreList.vue?vue&type=style&index=0&id=8ca89fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca89fa6",
  null
  
)

export default component.exports